import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0px -2px 20px 0px rgba(188, 188, 201, 0.03),
    0px 5px 11px 0px rgba(220, 223, 231, 0.39),
    0px 0px 3px 0px rgba(125, 132, 151, 0.14);
`;
